import { __assign, __rest } from "tslib";
import React, { memo } from 'react';
var DonutTotal = memo(function (_a) {
    var children = _a.children, total = _a.total;
    var label = total.label, value = total.value;
    var labelColor = label.fontColor, labelTypography = __rest(label, ["fontColor"]);
    var valueColor = value.fontColor, valueTypography = __rest(value, ["fontColor"]);
    return (React.createElement("text", { y: "-" + label.fontSize / 2, pointerEvents: "none", style: {
            textAnchor: 'middle',
            dominantBaseline: 'middle',
        } },
        React.createElement("tspan", { style: __assign({ fill: valueColor }, valueTypography) }, children),
        React.createElement("tspan", { x: "0", dy: label.fontSize + value.fontSize / 2, style: __assign({ fill: labelColor }, labelTypography) }, "Total")));
});
DonutTotal.displayName = 'DonutTotal';
export default DonutTotal;
